import React, { useState } from 'react';
import Header from './header';
import LeftPanel from './left-panel';
import RightPanel from './right-panel';
import * as S from './style';
import Footer from '../Footer'
import ErrorToast from '../../common/error-toast/ErrorToast';
import SuspectedPopup from './teacher-suspected-popup/suspected-poup';
import { parentUserCreationApi } from '../../../services/parent-register-api';
import { deleteCookie, getCookie, getItemFromSessionStorage, sendErrorToSentry, setLandingPageUrl, getQueryParamsObj, setCookieWithAge } from '../../../utils/web-helper';
import { trackToGtmFE } from '../../../utils/gtm-event-common';
import { useTurnstile } from '../../turnstile/context/TurnstileContext';
import { checkPlayDomainHealthAPI } from '../../../services/loggedout-api';

const ParentCreation = (props) => {
  const [signupError, setSignupError] = useState("");
  const [hideToast, setHideToast] = useState(false);
  const [showSuspectedPopup, setShowSuspectedPopup] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [suspectedFormData, setSuspectedFormData] = useState({
    name: "",
    email: "",
    contact_me_by_fax_only: "", // Honeypot field
  });
  const { getTurnstileToken } = useTurnstile();

  React.useEffect(() => {
		trackToGtmFE('visited_parent_signup_page'); 
    setLandingPageUrl();         
    setCookiesForBooksCompanion();
    checkPlayDomainHealthAPI();
    if(sessionStorage.getItem('show_flash_message')) {
      showFlashMessage('You\'ve cancelled your signup', 'error', 5000); 
      sessionStorage.removeItem('show_flash_message');
    }
  }, [])

  const setCookiesForBooksCompanion = () => {
    const href = window.location.href;
    const queryParams = getQueryParamsObj(href);
    if (queryParams.campaignBooks) {
      const cookieName = 'onboarding_campaign';
      const cookieData = {
        campaign_books: 'books',
      };
      setCookieWithAge(cookieName, JSON.stringify(cookieData));
    }
  };

  const userCreation = () =>{
    try{
      let time_zone = getCookie("timezone");

      // token used for server side validation
      const turnstileSecurityToken = getTurnstileToken();
            
      parentUserCreationApi({
        user: {
          type: "parent",
          email: email,
          password: password || "",
          signupFlow:"",
          time_zone,
          dob_day: "",
          dob_month: "",
          tnc_privacy: localStorage.getItem('is_privacy_policy_accepted'),
          email_preference: localStorage.getItem('is_email_preference'),
          landing_page_url: getItemFromSessionStorage('landing_page_url') || JSON.stringify(window.location.pathname),
          ad_group_id: getItemFromSessionStorage('ad_group_id')?.[0] || 'NA',
          is_bot_detected: suspectedFormData.contact_me_by_fax_only? true : '',
          ...(turnstileSecurityToken && {"cf-turnstile-response": turnstileSecurityToken})
        },
        turnstile_enabled: true
      })
      .then(()=>{
        window.trackEventOnGA('Initiated Sign up with', 'email','parent');
        deleteCookie('user_log');
        window.location.href = '/parent-dashboard';
      })
      .catch(e => {
        console.log(e);
      })
    }catch(error){
      console.error(err);
      let errorInfo = {
        extraMsg: 'User cration Api failed',
      };
      sendErrorToSentry(err, errorInfo)
    }
  }

  const onToastHidden = () =>{
    setHideToast(true);
  }

  const onParentCtaClick= (event) => {
    event.preventDefault();
    userCreation();
  }

  const onTeacherCtaClick= () => {
    window.location.href ='/teachers/register';
   }

  return (
    <>
      {showSuspectedPopup ? <SuspectedPopup
        email={email}
        password={password}
        onParentCtaClick={onParentCtaClick}
        onTeacherCtaClick={onTeacherCtaClick}
      ></SuspectedPopup> : <S.ParentCreationContainer>
        <Header />
        {signupError && !hideToast && <ErrorToast msg={signupError} onToastHidden={onToastHidden} />}
        <S.ParentSignupWrapper>
          <S.ParentSignupContainer>
            <S.ParentSignupTitleText>Create your free SplashLearn parent account</S.ParentSignupTitleText>
            <S.SignupContainer>
              <LeftPanel />
              <S.VerticalRule />
              <RightPanel
                setSignupError={setSignupError}
                setHideToast={setHideToast}
                setShowSuspectedPopup={setShowSuspectedPopup}
                email={email}
                setEmail={setEmail}
                password={password}
                setPassword={setPassword}
                setSuspectedFormData={setSuspectedFormData}
              />
            </S.SignupContainer>
          </S.ParentSignupContainer>
        </S.ParentSignupWrapper>
        <Footer />
      </S.ParentCreationContainer>}
    </>
  );
};

export default ParentCreation;